import * as React from 'react';

class SecondWindowNavBar extends React.Component<{}, {}> {
    render() {
        return <div className="second-window-nav">Second Window Nav - coming soon</div>;
    }
}

export default SecondWindowNavBar;



// WEBPACK FOOTER //
// ./src/components/layout/SecondWindowNavBar.tsx